import { useProductSummaryImage } from '../hooks/useProductSummaryImage';

const DiscountInsideContainer = () => {
	const { showBadge, badgeText } = useProductSummaryImage();

	return (
		<div
			className={`vtex-store-components-3-x-discountInsideContainer t-mini white absolute right-0 pv2 ph3 bg-emphasis z-1`}
		>
			{showBadge && <>60% {badgeText && <span>{badgeText}</span>}</>}
		</div>
	);
};

export default DiscountInsideContainer;
